import { render, staticRenderFns } from "./ReclamationChangelogPage.vue?vue&type=template&id=648a6a9c&"
import script from "./ReclamationChangelogPage.vue?vue&type=script&lang=js&"
export * from "./ReclamationChangelogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports